/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {ErrorType, ResponseData, showSnackbar} from '@dvrd/dvr-controls';
import React, {ForwardedRef, forwardRef, useImperativeHandle, useState} from 'react';
import {setVatNumber as sendRequest} from '../../../../util/requestSender';
import SetVatNumber from "./setVatNumber";
import {ActivateHandle} from "../../../../util/interfaces";
import Subscription from "../../../../models/subscriptionModel";

interface Props {
    onSuccess: (subscription: Subscription) => void;
}

function SetVatNumberController(props: Props, ref: ForwardedRef<ActivateHandle>) {
    const {onSuccess} = props;
    const [vatNumber, setVatNumber] = useState('');
    const [active, setActive] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<ErrorType>(null);

    function onActivate() {
        setActive(true);
    }

    function onClose() {
        setActive(false);
        setVatNumber('');
    }

    function onChange(value: string) {
        setVatNumber(value);
        if (error) setError(null);
    }

    function onFocus() {
        if (error) setError(null);
    }

    function onSubmit() {
        if (!isValid()) return;
        setLoading(true);
        sendRequest({
            data: {vat_number: vatNumber}, callback: (data: ResponseData) => {
                setLoading(false);
                if (data.success) {
                    showSnackbar('Het BTW-nummer is opgeslagen');
                    onClose();
                    onSuccess(new Subscription(data.subscription));
                } else
                    setError(data.message ?? 'Het instellen van het BTW-nummer is niet gelukt');
            }
        })
    }

    function isValid(): boolean {
        if (!vatNumber) {
            setError('Vul het BTW-nummer in');
            return false;
        }
        return true;
    }

    useImperativeHandle(ref, () => ({
        activate: onActivate,
    }));

    return (
        <SetVatNumber onChange={onChange} onFocus={onFocus} onSubmit={onSubmit} onClose={onClose} vatNumber={vatNumber}
                      active={active} loading={loading} error={error}/>
    )
}

export default forwardRef<ActivateHandle, Props>(SetVatNumberController);